<div class="startup-loader">
  <div class="startup-loader__content">
    <!-- CheckPoint Logo -->
    <div class="startup-loader__logo">
      <img [src]="'logos/checkpoint-icon.png' | envPrefix:'brand'" alt="CheckPoint" class="startup-loader__logo-img" />
    </div>

    <h1 class="startup-loader__title">CheckPoint</h1>
    <p class="startup-loader__subtitle">Asset Management & Interaction Tracking</p>

    <!-- Fake loading log -->
    <div class="startup-loader__log">
      <div class="startup-loader__log-entry">
        <app-icon name="loader" class="startup-loader__spinner" [size]="16" />
        <span class="startup-loader__message">{{ currentMessage() }}</span>
      </div>
    </div>
  </div>
</div>